export const JOB_PLANNER_ACTIONS = {
    TEMPLATE_LIST : "TEMPLATE_LIST"
}